import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';
import Vuelidate from 'vuelidate';
import lodash from 'lodash';
import VueGtm from 'vue-gtm';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import iban from 'iban';
import countryList from 'country-list';
import AOS from 'aos';
import constants from '@/constants';


Vue.prototype.$http = axios;
Vue.prototype._ = lodash;
Vue.prototype.iban = iban;
Vue.prototype.countryList = countryList;
Vue.config.productionTip = false;
Vue.use(Vuelidate);

const isProd = process.env.NODE_ENV === 'production';
const defaultGtmContainerIdValue = "GTM-#######";

const urlParams = new URLSearchParams(window.location.search);
let tenantId = urlParams.get("tenantId");
const appElement = document.getElementById('app');

if (tenantId === undefined || tenantId === null) {
  if (appElement != undefined && appElement != null) {
    if (appElement.dataset.tenant != undefined && appElement.dataset.tenant != null)
      tenantId = appElement.dataset.tenant;
  }
}

Vue.use(AOS);

axios
  .get(constants.restBaseURL + "/public/properties?tenantId=" + tenantId)
  .then(response => {
    let properties = response.data.properties;

    if (properties !== null && properties !== undefined) {
      let property = properties.find(((property: { name: string }) => property.name === 'GOOGLE_CONTAINER_ID'));

      if (property !== null && property !== undefined && property.textValue !== defaultGtmContainerIdValue) {
        createGtm(true, property.textValue);
      } else {
        createGtm(false, "unknown");
      }
      createVue();
    } else {
      createGtm(false, "unknown");
      createVue();
    }
  },
    error => {
      console.log(error);
      createGtm(false, "unknown");
      createVue();
    });

function createGtm(enabled: boolean, id: string) {
  Vue.use(VueGtm, {
    id: id,
    enabled: enabled,
    debug: !isProd,
    loadScript: enabled,
    vueRouter: router,
  });
};

function createVue() {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount('#app');
}
